import { CurrencyDimensionQuery } from '~/queries/components/Organisms/CurrencyDimension.query';
import type { CurrencyDimensionQueryResult } from '~/sanity/types';
type Currency = {
  code: string;
  label: string;
};
export async function useCurrency() {
  const route = useRoute();
  const currencyQueryParameter = route.query.in;
  const { heartbeatStorable } = useWwwStorage();

  const defaultCurrency = useState<string>('default-currency', () => '');
  const currencyOptions = ref<Currency[]>([]);
  const { data: currencyDimension } =
    await useWwwSanityQuery<CurrencyDimensionQueryResult>(CurrencyDimensionQuery);
  currencyOptions.value =
    currencyDimension.value?.variants
      .filter(
        (currency: { variantName: string; variantValue: string }) =>
          currency.variantName.toLowerCase() !== 'default'
      )
      .map((currency: { variantName: string; variantValue: string }) => ({
        code: currency.variantValue.toLowerCase(),
        label: currency.variantName,
      })) || [];
  const computedCurrency = computed(() => {
    let queryCurrency: string | undefined;
    if (typeof currencyQueryParameter === 'string') {
      queryCurrency = currencyQueryParameter?.toLowerCase();
    }
    const isQueryValid = currencyOptions.value.some((c) => c.code === queryCurrency);
    if (queryCurrency && isQueryValid) {
      return queryCurrency;
    }
    const heartbeatCurrency = heartbeatStorable.value?.currency?.toLowerCase();
    const isHeartbeatValid = currencyOptions.value.some((c) => c.code === heartbeatCurrency);
    if (heartbeatCurrency && isHeartbeatValid) {
      return heartbeatCurrency;
    }
    return 'usd';
  });
  watch(
    computedCurrency,
    (val) => {
      defaultCurrency.value = val;
    },
    { immediate: true }
  );

  const setCurrency = (newCurrency: string) => {
    defaultCurrency.value = newCurrency.toLowerCase();
  };

  return {
    defaultCurrency,
    currencyOptions: currencyOptions.value,
    setCurrency,
  };
}
